import { render, staticRenderFns } from "./AddPopupHeaderApp.vue?vue&type=template&id=3db3e77e"
import script from "./AddPopupHeaderApp.vue?vue&type=script&lang=js"
export * from "./AddPopupHeaderApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports